import React from 'react';
import AuthBasicRoutes from '../components/auth/basic/AuthBasicRoutes';

const FLOATING_CIRCLES = [
  { size: 'lg', left: '8%', delay: '0s', duration: '18s' },
  { size: 'sm', left: '18%', delay: '3s', duration: '12s' },
  { size: 'md', left: '32%', delay: '1s', duration: '20s' },
  { size: 'xs', left: '44%', delay: '6s', duration: '14s' },
  { size: 'xl', left: '58%', delay: '2s', duration: '24s' },
  { size: 'sm', left: '72%', delay: '5s', duration: '17s' },
  { size: 'md', left: '84%', delay: '0s', duration: '22s' },
  { size: 'xs', left: '90%', delay: '8s', duration: '13s' },
  { size: 'lg', left: '64%', delay: '10s', duration: '28s' },
  { size: 'sm', left: '26%', delay: '12s', duration: '16s' },
  { size: 'md', left: '12%', delay: '9s', duration: '19s' },
  { size: 'xs', left: '52%', delay: '4s', duration: '15s' }
];

const AuthBasicLayout = ({ basePath }) => (
  <section className="psi-auth-portal">
    <div className="psi-auth-portal__veil" />
    <div className="psi-auth-portal__texture" />
    <ul className="psi-auth-circles" aria-hidden="true">
      {FLOATING_CIRCLES.map((item, index) => (
        <li
          key={`${item.left}-${index}`}
          className={`psi-auth-circle psi-auth-circle--${item.size}`}
          style={{
            left: item.left,
            animationDelay: item.delay,
            animationDuration: item.duration
          }}
        />
      ))}
    </ul>

    <div className="psi-auth-stage">
      <AuthBasicRoutes basePath={basePath} />
    </div>
  </section>
);

export default AuthBasicLayout;
